import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { findOriginalChildIndex } from './util';
import styles from './Carousel.module.scss';

HavenlyCarousel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  onSelected: PropTypes.func,
};

HavenlyCarousel.defaultProps = {
  className: '',
  onSelected: undefined,
};

const INFINITE = true;

export default function HavenlyCarousel(props) {
  const carouselRef = useRef(null);
  const {
    children,
    className,
    onSelected,
  } = props;

  // initialize
  useEffect(() => {
    if (onSelected) {
      onSelected(0);
    }
  }, []);

  const handleAfterChange = (previousSlide, carouselState) => {
    if (!onSelected) {
      return undefined;
    }

    if (!INFINITE) {
      return carouselState.currentSlide;
    }

    return onSelected(findOriginalChildIndex(carouselRef, carouselState, children.length));
  };

  return (
    <div
      className={ `${styles.Wrapper} ${className}` }
    >
      <Carousel
        additionalTransfrom={ 0 }
        afterChange={ handleAfterChange }
        arrows={ Array.isArray(children) && children.length > 1 }
        autoPlaySpeed={ 3000 }
        centerMode={ false }
        className=""
        containerClass={ styles.CarouselContainer }
        deviceType="desktop"
        dotListClass=""
        draggable
        focusOnSelect={ false }
        infinite={ INFINITE }
        itemClass={ styles.CarouselItem }
        keyBoardControl
        minimumTouchDrag={ 80 }
        ref={ carouselRef }
        removeArrowOnDeviceType={ ['mobile', 'tablet'] }
        renderButtonGroupOutside
        renderDotsOutside
        responsive={{
          desktop: {
            breakpoint: {
              max: 3000,
              min: 1024,
            },
            items: 1,
          },
          mobile: {
            breakpoint: {
              max: 464,
              min: 0,
            },
            items: 1,
          },
          tablet: {
            breakpoint: {
              max: 1024,
              min: 464,
            },
            items: 1,
          },
        }}
        showDots={ Array.isArray(children) && children.length > 1 }
        ssr
        sliderClass={ styles.CarouselSlider }
        slidesToSlide={ 1 }
        swipeable
      >
        {children}
      </Carousel>
    </div>
  );
}
